import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import bannerBg from "images/bg.jpg";
import bannerBg1 from "images/bg1.jpg";
import bannerBg2 from "images/bg2.jpg";
import bannerBg3 from "images/bg3.jpg";
import bannerBg4 from "images/bg4.jpg";
import bannerBg5 from "images/bg5.jpg";
import bannerBg6 from "images/bg6.jpg";
import bannerBg7 from "images/bg7.jpg";
import bannerBg8 from "images/bg8.jpg";
import theWire from "images/thewire-logo.png";
import SearchInput from "components/shared/SearchInput";
import { LandingTopContainer } from "./styles";

function LandingTop(props) {
  const { heroTitle, showEasyCheckout } = props;

  const [state, setState] = useState({
    backgroundImage: bannerBg,
    searchInputValue: "",
    formError: false
  });

  React.useEffect(() => {
    const images = [
      bannerBg,
      bannerBg1,
      bannerBg2,
      bannerBg3,
      bannerBg4,
      bannerBg5,
      bannerBg6,
      bannerBg7,
      bannerBg8
    ];
    setState((prev) => ({
      ...prev,
      backgroundImage: images[Math.floor(Math.random() * images.length)]
    }));
  }, []);

  return (
    <LandingTopContainer style={{ backgroundImage: `url(${state.backgroundImage})` }}>
      <div className="layer" />
      <div className="callout">
        {props.wire ? (
          <img className="wireLogo" src={theWire} alt="THE WIRE" />
        ) : (
          <h1>
            {heroTitle !== null ? heroTitle : "Authentic videos, extraordinary social performance"}
          </h1>
        )}
        <SearchInput homepage />
      </div>

      {!showEasyCheckout && props.children && <>{props.children}</>}
    </LandingTopContainer>
  );
}

LandingTop.propTypes = {
  clearAllSearch: PropTypes.func.isRequired,
  history: PropTypes.shape().isRequired,
  showEasyCheckout: PropTypes.bool
};

LandingTop.defaultProps = {
  showEasyCheckout: true
};

export default withRouter(LandingTop);
